import * as types from '../actions/actionTypes';
import initialState from './initialState';

export default function wasteReadingReducer(
  state = initialState.wasteReadings,
  action
) {
  switch (action.type) {
    case types.LOAD_WASTE_WATER_READINGS_SUCCESS:
      return action.wasteReadings;

    case types.CREATE_WASTE_WATER_READING_SUCCESS:
      return [...state, Object.assign({}, action.wasteReading)];

    case types.UPDATE_WASTE_WATER_READING_SUCCESS:
      return [
        ...state.filter((reading) => reading.id !== action.wasteReading.id),
        Object.assign({}, action.wasteReading),
      ];

    case types.DELETE_WASTE_WATER_READING_SUCCESS:
      return state.filter((reading) => reading.id !== action.wasteReading.id);

    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/reducers/wasteReadingReducer.js